module.exports = __webpack_public_path__ + "static/img/img-rate-40@3x.0a74e6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/img-rate-40@3x.png
// module id = Rg6V
// module chunks = 18